import React from 'react';
import { Helmet } from 'react-helmet';
import { useData } from '../context/DataContext';

const SEO = ({ title, description, image, url, type = 'website', schema }) => {
  const { bio } = useData();
  const siteTitle = bio?.name || "Leon Krykhtin";
  const siteDescription = bio?.description?.[0] || "Architect & New Media Artist"; // Use first paragraph as default
  const siteUrl = "https://leon-krykhtin.com"; // Assuming a domain or use a placeholder
  const defaultImage = "https://customer-assets.emergentagent.com/job_krykhtin-showcase/artifacts/l3lkiwpr_IMG_9359.jpeg";

  const metaTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const metaDescription = description || siteDescription;
  const metaImage = image || defaultImage;
  const metaUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="image" content={metaImage} />
      <link rel="canonical" href={metaUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:site_name" content={siteTitle} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@leonkreeh" /> 
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* Structured Data (JSON-LD) */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
